// Entry point for the web components - minimalist version
export { InnovaChatElement } from './InnovaChatElement';

// Define global namespace
declare global {
  interface Window {
    InnovaChat?: {
      version: string;
    };
  }
}

// Simple global config object
if (!window.InnovaChat) {
  window.InnovaChat = {
    version: '1.0.0',
  };
}
